import React, { useState } from 'react';
import PageTableLayout from '../components/PageTableLayout';

const breadcrumb = (
  <span>
    Home &nbsp;/&nbsp; Webber &nbsp;/&nbsp; <span className="text-gray-700">Websites</span>
  </span>
);

const columns = [
  { key: 'name', title: 'Website Name' },
  { key: 'domain', title: 'Domain' },
  { key: 'status', title: 'Status' },
];

const mockData = [
  { id: 1, name: 'ABC SCHOOL', domain: 'abcschool.edu', status: 'Active' },
  { id: 2, name: 'ABC SCHOOL 2', domain: 'abcschool2.edu', status: 'Active' },
];

const Websites = () => {
  const [data, setData] = useState(mockData);
  const filters = [
    <input key="domain" className="border px-2 py-1 rounded text-sm" placeholder="Enter domain" />,
    <select key="status" className="border px-2 py-1 rounded text-sm">
      <option>Select Status</option>
      <option>Active</option>
      <option>Inactive</option>
    </select>,
    <button key="filter" className="bg-blue-600 text-white px-3 py-1 rounded text-xs">Filter</button>
  ];
  const handleEdit = (row) => alert(`Edit: ${row.name}`);
  const handleAddNew = () => alert('Add New Website');
  return (
    <PageTableLayout
      title="Websites"
      breadcrumb={breadcrumb}
      columns={columns}
      data={data}
      filters={filters}
      onEdit={handleEdit}
      onAddNew={handleAddNew}
    />
  );
};

export default Websites;
